export default __webpack_public_path__ + "static/media/VideoThumbnail4.4394af31.svg";